import { API_BASE_URL } from '../api/client';

/**
 * The signed-out card: the one place a human can start a login on purpose.
 * Extracted so both the post-logout interstitial (`/logged-out`) and the
 * shell's signed-out state (no session, or a data 401 mid-session) render the
 * same dead end — the app must never be without a visible way to authorize.
 *
 * "Sign in" is a FULL page navigation, not a client-side route: the session
 * cookie is minted on the api's redirect chain from Yandex, so it needs a real
 * document load.
 */
export function SignedOutCard({
  title,
  hint,
  warning,
}: {
  title: string;
  hint: string;
  /** Amber line above the hint — a failed sign-in attempt, for instance. */
  warning?: string;
}) {
  return (
    <main className="signedout">
      <div className="signedout__card">
        <span className="signedout__mark" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="26" height="26">
            <path
              d="M14 4h4a1.5 1.5 0 0 1 1.5 1.5v13A1.5 1.5 0 0 1 18 20h-4"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
            />
            <path
              d="M15.5 12H6m0 0 4-4m-4 4 4 4"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <h1 className="signedout__title">{title}</h1>
        {warning ? <p className="signedout__warning">{warning}</p> : null}
        <p className="signedout__hint">{hint}</p>
        {/* Full page navigation, not a client-side route: the session cookie is
            minted on the api's redirect chain, so it must be a real document. */}
        <a className="btn btn--primary signedout__action" href={`${API_BASE_URL}/auth/login`}>
          Sign in
        </a>
      </div>
    </main>
  );
}
